export const idfDepartments = ['75', '77', '78', '91', '92', '93', '94', '95']
